import { QUERY_ROOT_NAME } from './constants';
import type { CachedListBaseQueryConfig } from './insertIntoCachedListBaseQueries';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const chatHomeListCacheConfig = {
  parentKey: QUERY_ROOT_NAME,
  fieldName: 'chat_home',
  getEntityKey: (cache, chatId: string) =>
    cache.keyOfEntity({
      __typename: 'chat',
      id: chatId,
    }),
  getLinkPartition: (cache, entityKey) => {
    const isHidden = cache.resolve(entityKey, 'is_hidden');
    return typeof isHidden === 'boolean' ? isHidden : undefined;
  },
  getBaseQueryPartition: (arguments_) => {
    const where = arguments_.where;
    if (!isRecord(where) || '_or' in where) {
      return undefined;
    }

    const isHiddenComparison = where.is_hidden;
    if (
      !isRecord(isHiddenComparison) ||
      typeof isHiddenComparison._eq !== 'boolean'
    ) {
      return undefined;
    }

    return isHiddenComparison._eq;
  },
} satisfies CachedListBaseQueryConfig<string, boolean>;

export default chatHomeListCacheConfig;
